import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { cfpBaseUrl } from '../../network/urls';
import { buildTree } from '../../services/Functions';

const initialState = {
    name: "",
    userId: "",
    roleTypeId: "",
    roleTypeName: "",
    phoneNo: "",
    email: "",
    cnic: "",
    code: "",
    roleId: null,
    roleName: "",
    showAllApplicationsFlag: null,
    cscID: "",
    csc : "",
    cfcLevelId: "",
    cfcLevelName: "",
    divisionCode: "",
    circleCode: "",
    hierarchy: null,
    userStatus: "",
    currentDateTime: "",
    profilePicture: "",
    permissions: [],
    token: "",
    wmsPrivateToken: '',
    loading: false,
    error: null,
}

export const signIn = createAsyncThunk(
    'auth/signIn',
    async (credentials, { rejectWithValue }) => {
        try {
            const formdata = new FormData();
            formdata.append("userId", credentials.UserName);
            formdata.append("password", credentials.Password);
            formdata.append("isLoggedInFromMobile", '0');
            const response = await fetch(cfpBaseUrl + 'customerFaciliationPortal/signin', {
                method: 'POST',
                body: formdata,
                redirect: 'follow',
            });

            const data = await response.json();

            if (!response.ok || data.status !== '200') {
                throw new Error(data.message || 'Sign API issue!');
            }

            return data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        signOut: (state) => {
            Object.assign(state, initialState);
        },
        stopLoading: (state) => {
            state.loading = false;
        },
        updateName: (state, action) => {
            state.name = action.payload
        },
        updatePhone: (state, action) => {
            state.phoneNo = action.payload
        },
        updateEmail: (state, action) => {
            state.email = action.payload
        },
        updateProfilePicture: (state, action) => {
            state.profilePicture = action.payload
        },
        setUserData: (state, action) => {
            const payload = action.payload;
            state.name = payload.name;
            state.userId = payload.userId;
            state.roleTypeId = payload.roleTypeId;
            state.roleTypeName = payload.roleTypeName;
            state.phoneNo = payload.phoneNo;
            state.email = payload.email;
            state.cnic = payload.cnic;
            state.code = payload.code;
            state.roleId = payload.roleId;
            state.roleName = payload.roleName;
            state.showAllApplicationsFlag = payload.showAllApplicationsFlag;
            state.cscID = payload.cscID;
            state.csc = payload.csc;
            state.cfcLevelId = payload.cfcLevelId;
            state.cfcLevelName = payload.cfcLevelName;
            state.divisionCode = payload.divisionCode;
            state.circleCode = payload.circleCode;
            state.hierarchy = payload.hierarchy;
            state.currentDateTime = payload.currentDateTime;
            state.userStatus = payload.userStatus;
            state.profilePicture = payload.profilePicture;
            state.permissions = buildTree(payload.permissions);
            state.token = payload.token;
            state.wmsPrivateToken = payload.wmsPrivateToken;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(signIn.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(signIn.fulfilled, (state) => {
                 console.log("Success")
                state.loading = false;
                // No auto-login here to prevent unintended logins
            })
            .addCase(signIn.rejected, (state, action) => {
                console.log("rejected")
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const {
    signOut,
    stopLoading,
    updateName,
    updatePhone,
    updateEmail,
    updateProfilePicture,
    setUserData
} = authSlice.actions;

export default authSlice.reducer;
